import { BACKEND_URL } from "@/lib/api";
import SIZES from "../../data/imgsizes.json";

const localSrcSet = (src) => {
  const entry = SIZES[src];
  if (!entry || !entry[1].length) return undefined;
  const base = src.slice(0, -5);
  return [...entry[1].map((w) => `${base}-${w}.webp ${w}w`), `${src} ${entry[0]}w`].join(", ");
};
export const SiteImage = ({ src, alt, priority = false, sizes = '(min-width: 1024px) 50vw, 100vw', ...props }) => {
  const resolved = src.startsWith('/api/') ? `${BACKEND_URL}${src}` : src;
  const responsive = src.startsWith('https://images.unsplash.com/');
  const local = localSrcSet(src);
  const srcSet = local || (responsive ? [480, 800, 1200, 1600].map((width) => {
    const url = new URL(src); url.searchParams.set('w', width); url.searchParams.set('q', '75'); url.searchParams.set('auto', 'format');
    return `${url.toString()} ${width}w`;
  }).join(', ') : undefined);
  return <img src={resolved} srcSet={srcSet} sizes={responsive || local ? sizes : undefined} alt={alt} loading={priority ? 'eager' : 'lazy'} fetchPriority={priority ? 'high' : 'auto'} decoding="async" {...props} />;
};

export const Photo = ({ src, alt, caption, pos, ratio = "aspect-[16/10] sm:aspect-[21/9] lg:aspect-[3/1]", className = "", testid }) => (
  <figure data-testid={testid} className={`relative overflow-hidden rounded-3xl bg-[#E6E3DD] ${ratio} ${className}`}>
    <SiteImage src={src} alt={alt} sizes="(min-width: 1320px) 1240px, 100vw" className="absolute inset-0 w-full h-full object-cover" style={pos ? { objectPosition: pos } : undefined} />
    {caption && <figcaption className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/60 to-transparent px-5 pb-4 pt-12 sm:px-7 sm:pb-6 text-white font-head font-semibold text-sm sm:text-base">{caption}</figcaption>}
  </figure>
);

export const PhotoBand = (props) => <div className="max-w-[1320px] mx-auto px-5 md:px-10 py-6 md:py-10"><Photo {...props} /></div>;
